export default {

    methods: {
        //Shows general delivery time (like "12 hour delivery")
        deadlineNameSingular: function(deadline) {
            if (deadline == 1) return '12 hour';
            if (deadline == 2) return '24 hour';
            if (deadline == 3) return '2 day';
            if (deadline == 4) return '3 day';
            if (deadline == 5) return '5 day';
            if (deadline == 6) return '7 day';
            if (deadline == 7) return '14 day';
        },

    },

}